<div class="container-options-meal-plan mb-xlg">
  <div nz-row [nzGutter]="[30, 30]">

    <div class="shepherd-new-meal-plan" nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="12" *ngIf="userLogged?.experts && showOptions">
      <div class="option card-container-shadow"
        [class.not-shadow]="!shadow">
        <div class="img">
          <img loading="lazy" src="./../../../assets/images/select-meal-plan.jpg" alt=""
            style="position: relative; bottom: 9px;">
          <div>
            <p class="text-info mb-sm">Se creará un nuevo plan
              alimenticio dedicado solo para este paciente.
            </p>
            <button
              (click)="onEmitSelectOptionMealPlan(optionsMealPlanEnum.NEW)"
              nz-button nzType="primary"
              class="btn-default" nzGhost>
              <i nz-icon nzType="plus" nzTheme="outline"></i>
              CREAR DESDE CERO
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="shepherd-select-meal-plan" nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="12" *ngIf="userLogged?.experts && showOptions">
      <div class="option card-container-shadow"
        [class.not-shadow]="!shadow">
        <div class="img">
          <img loading="lazy" src="./../../../assets/images/select-2.jpg" alt="">
          <div>
            <p class="text-info mb-sm">Puedes elegir entre una
              variedad de planes de alimentación ya existentes
              y después adaptarlo al paciente.</p>
            <button
              (click)="onEmitSelectOptionMealPlan(optionsMealPlanEnum.SELECT)"
              nz-button nzType="primary"
              nzGhost>
              <i nz-icon nzType="check-square" nzTheme="outline"></i>
              SELECCIONAR PLAN
            </button>
          </div>
        </div>
      </div>
    </div>

    <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="24" *ngIf="temporalMealPlan && temporalMealPlan.name">
      <div class="card-container-shadow shepherd-meal-plan" id="shepherd-meal-plan" [class.not-shadow]="!shadow">
        <div class="title-label mb-xlg text-subtitle-bold-upper">
          <p>{{ title }}</p>
          <p class="text-info text-lower-initial mt-xxs shepherd-meal-plan-instructions">{{ subtitle}}</p>
        </div>
        <div nz-row [nzGutter]="[30, 30]">
          <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24"
            [nzLg]="showOptionsActivePlan ? 12 : 24">
            <p class="text-title-md shepherd-meal-plan-name mb-xxs">{{ temporalMealPlan.name}}</p>
            <p class="text-info mb-md" nz-typography nzEllipsis
              [nzEllipsisRows]="3">{{
              temporalMealPlan.instructions }}</p>
            <p class="text-info-bold-xs mb-xs">MACRONUTRIENTES</p>
            <div class="mb-xlg macronutrients macros-in-select
              d-flex justify-content-between"
              [class.max-width-macros]="!showOptionsActivePlan">
              <div class="macronutrient d-flex flex-column
                justify-content-center align-items-center">
                <img loading="lazy" class="img-macro"
                  src="./../../../assets/images/icons/icons8-chocolatina-100.png"
                  alt="">
                <p class="text-info-bold-xs">Calorías</p>
                <p class="text-info text-bold text-small">{{
                  +(temporalMealPlan.nutritionalProperties?.energy_kcal?.toFixed(2))
                  ?? 0 }} kcal</p>
              </div>
              <div class="macronutrient d-flex flex-column
                justify-content-center align-items-center">
                <img loading="lazy" class="img-macro"
                  src="./../../../assets/images/icons/icons8-sunny-side-up-huevos-100.png"
                  alt="">
                <p class="text-info-bold-xs">Grasas</p>
                <p class="text-info text-bold text-small">{{
                  +(temporalMealPlan.nutritionalProperties?.totalFat_g?.toFixed(2))
                  ?? 0 }} g</p>
              </div>
              <div class="macronutrient d-flex flex-column
                justify-content-center align-items-center">
                <img loading="lazy" class="img-macro"
                  src="./../../../assets/images/icons/icons8-pastel-de-nata-100.png"
                  alt="">
                <p class="text-info-bold-xs">H.C</p>
                <p class="text-info text-bold text-small">{{
                  +(temporalMealPlan.nutritionalProperties?.carbohydrate_g?.toFixed(2))
                  ?? 0 }} g</p>
              </div>
              <div class="macronutrient d-flex flex-column
                justify-content-center align-items-center">
                <img loading="lazy" class="img-macro"
                  src="./../../../assets/images/icons/icons8-jamon-100.png"
                  alt="">
                <p class="text-info-bold-xs">Proteínas</p>
                <p class="text-info text-bold text-small">{{
                  +(temporalMealPlan.nutritionalProperties?.protein_g?.toFixed(2))
                  ?? 0 }} g</p>
              </div>
              <div class="macronutrient d-flex flex-column
                justify-content-center align-items-center">
                <img loading="lazy" class="img-macro"
                  src="./../../../assets/images/icons/icons8-heno-100.png"
                  alt="">
                <p class="text-info-bold-xs">Fibra</p>
                <p class="text-info text-bold text-small">{{
                  +(temporalMealPlan.nutritionalProperties?.dietaryFiber_g?.toFixed(2))
                  ?? 0 }} g</p>
              </div>
            </div>
            <button *ngIf="showOptionsActivePlan"
              (click)="onEmitSelectOptionMealPlan(optionsMealPlanEnum.FILL)"
              nz-button
              nzType="primary"
              class="shepherd-button-open-meal-plan"
            >ABRIR plan de alimentación
            </button>
          </div>
          <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="12"
            *ngIf="temporalMealPlan">
            <div class="shepherd-button-assign-meal-plan-to-appointment" *ngIf="!mealPlanAppointment && userLogged?.experts && showOptionsActivePlan">
              <p class="text-info mb-sm">Puedes asignar el plan
                alimenticio actual a una de tus citas.</p>
              <button nz-button nzType="primary"
                (click)="onEmitAssignToAppointment()"
                nzGhost>ASIGNAR A UNA CITA
              </button>
            </div>
            <div *ngIf="mealPlanAppointment">
              <p class="text-info mb-sm">Este plan de alimentación ya está asignado a una cita.</p>
              <app-card-meal-plan-to-appointment
                [appointments]="[mealPlanAppointment]"
                [showSelection]="!mealPlanAppointment"></app-card-meal-plan-to-appointment>
              <p *ngIf="showOptionsActivePlan && userLogged?.experts" class="text-link mt-xs
                text-end" (click)="onEmitAssignToAppointment()">Asignar plan de alimentación a otra cita</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div nz-col [nzXs]="24" *ngIf="showDownloadOption">
      <div class="option card-container-shadow shepherd-download-pdf"
           [class.not-shadow]="!shadow">
        <div class="img">
          <img loading="lazy" src="./../../../assets/images/4537623.jpg" alt=""
               style="position: relative; bottom: 9px;">
          <div>
            <p class="text-info mb-sm">Puedes descargar un pdf con información referente al diagnóstico, mediciones, resultados bioquímicos y plan alimenticio actualmente asignado.</p>
            <button
              (click)="onDownloadTemplate()"
              nz-button nzType="primary"
              class="btn-default shepherd-button-download-pdf" nzGhost>
              <i nz-icon nzType="download" nzTheme="outline"></i>
              DESCARGAR
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
